"use client";
import { signIn, useSession } from "next-auth/react";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@seismic/mantle";

export default function LoginPage() {
  const { status } = useSession();
  const router = useRouter();
  const callbackUrl =
    typeof window !== "undefined"
        ? new URLSearchParams(window.location.search).get("callbackUrl") || "/"
        : "/";


  useEffect(() => {
    if (status === "authenticated") {
      router.replace(callbackUrl);
    }
  }, [status, router, callbackUrl]);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex min-h-screen w-screen">
        <div className="flex flex-col items-center justify-center min-h-screen w-1/2">
            <div className="w-[500px] gap-2 p-4 flex flex-col">
                <div className="flex flex-col items-center">
                    <img src="/assets/seismic.png" alt="Seismic Logo" className="h-10 mb-4" />
                </div>
                <h4 className="text-lg font-semibold">Partner Enablement Network</h4>
                <p>Welcome to the Seismic Partner Enablement Network, the Financial Services industry hub for connecting and enabling industry partnerships through content and data sharing.</p>
                <hr />
                <h4 className="text-lg font-semibold">Sign In</h4>
                <p>Select sign in method to access the Partner Enablement Network</p>
                <div className="gap-6 mt-2 flex flex-row items-center">
                  <Button
                  label="Sign In with SSO"
                  size="md"
                  variant="primary"
                  style={{
                    backgroundColor: '#3C1A4B',
                    color: '#FFFFFF',
                    transition: 'background-color 0.2s',
                    lineHeight: '2',
                    width: '48%'
                  }}
                  onClick={() => signIn("seismic", { callbackUrl, redirect: true })}
                  onMouseOver={e => {
                    (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'rgba(60,26,75,0.8)';
                  }}
                  onMouseOut={e => {
                    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#3C1A4B';
                  }}
                />
                <Button
                  label="Sign In with Seismic Account"
                  size="md"
                  onClick={() => signIn("seismic", { callbackUrl, redirect: true }, { authentication_mode: 'directlogon' })}
                />
                </div>
            </div>
            <div className="mt-4 text-sm flex flex-col items-center absolute bottom-8">
                <p className="mb-2 flex font-bold items-center justify-center">
                    Powered by
                    <img src="/assets/seismic.png" alt="Seismic Logo" className="h-4 inline-block ml-1" />
                </p>
                <p style={{ color:'#535B64'}}>One account for Seismic Content, Learning, LiveSocial & Knowledge</p>
            </div>
        </div>
        <div
          className="flex-1 bg-white flex items-center justify-center w-1/2"
          style={{
            backgroundImage: "url('/assets/login-right-cover.svg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100vh",
          }}
        >
        </div>
    </div>
    
  );
}
